import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Fragment, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableRow, styled, useTheme } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { BoxContainer } from '../layouts/Theme';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import { useI18N } from '../context/I18NContext';
import { useFlow } from '../context/FlowContext';
import { useSettings } from '../context/SettingsContext';
import useWidgetStore from '../store/useWidgetStore';
import useDataStore from '../store/useDataStore';
import { queryClient } from "../../../api/ApiClient";
import { isMobile } from '../../../helpers/browser';
import { moneyFormat } from '../helpers/general';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    textAlign: 'right',
    width: '6em'
}));
export default function ThankYou(props) {
    const { t, ts } = useI18N();
    const navigate = useNavigate();
    const [showRestart, setShowRestart] = useState(false);
    const [apptypeStr, setApptypeStr] = useState();
    const [resourceStr, setResourceStr] = useState();
    const [capacityStr, setCapacityStr] = useState();
    const [dates, setDates] = useState([]);
    const [smallMode, setSmallMode] = useState(false);
    const { showSelectedResource, staticData, widgetMode, orientation } = useSettings();
    const flow = useFlow();
    const theme = useTheme();
    const { cart, booking, enabled, consumer, isGuest, setEnabled, setIsAccount, setIsGuest, setIsLoginAccount, setIsNewAccount, setSelectedApptype, setSelectedGroup, setSelectedDate, setSelectedTime, selectedCapacity, selectedCapacityGroups, resetCart, setConsumer, resetBooking, language, setIsPaying, } = useWidgetStore();
    const { apptypes, resources, getProduct } = useDataStore();
    useEffect(() => {
        setSmallMode(orientation === "vertical" || isMobile);
        setEnabled(Object.assign(Object.assign({}, enabled), { apptype: true, resource: true }));
        setSelectedApptype();
        setSelectedGroup();
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (((_b = (_a = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.showRestart) !== undefined) {
            setShowRestart((_d = (_c = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.showRestart);
        }
    }, [flow.currentView]);
    useLayoutEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_b = (_a = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.redirect) {
            if (widgetMode === 'standalone') {
                window.location.href = (_d = (_c = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.redirect;
            }
            else {
                window.parent.postMessage({
                    type: 'redirect',
                    url: (_f = (_e = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.redirect
                }, '*');
            }
        }
        if ((_g = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _g === void 0 ? void 0 : _g.config) {
            if ((_k = (_j = (_h = flow === null || flow === void 0 ? void 0 : flow.currentView) === null || _h === void 0 ? void 0 : _h.config) === null || _j === void 0 ? void 0 : _j.showRestart) !== null && _k !== void 0 ? _k : true) {
                // This is a useLayoutEffect, so runs after all rendering is done
                //  setShowRestart(flow?.currentView?.config?.showRestart ?? true)
            }
            else {
                setIsGuest(true);
                setIsAccount(false);
                setIsLoginAccount(false);
                setIsNewAccount(false);
            }
        }
    }, [flow.currentView]);
    useEffect(() => {
        if (isGuest && (consumer === null || consumer === void 0 ? void 0 : consumer.id)) {
            setConsumer();
        }
    }, [isGuest, consumer === null || consumer === void 0 ? void 0 : consumer.id]);
    useEffect(() => {
        var _a;
        if (((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            let _dates = [];
            booking.appointments.forEach((_appointment) => {
                _dates.push(dayjs(_appointment.date).locale(language).format('dddd D MMMM HH:mm'));
            });
            setDates(_dates);
        }
    }, [booking === null || booking === void 0 ? void 0 : booking.appointments]);
    useEffect(() => {
        var _a;
        if (((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0 && resources.length > 0) {
            let appointment = booking.appointments[0];
            let component = appointment.components[0];
            let _resources = [];
            component.resources.forEach((resource_id) => {
                let resource = staticData === null || staticData === void 0 ? void 0 : staticData.resources.find((resource) => {
                    return resource.id === resource_id;
                });
                if (resource) {
                    _resources.push(resource.name);
                }
            });
            setResourceStr(_resources.join(', '));
        }
    }, [resources, booking === null || booking === void 0 ? void 0 : booking.appointments]);
    useEffect(() => {
        var _a;
        if (((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0 && resources.length > 0) {
            let appointment = booking.appointments[0];
            let component = appointment.components[0];
            let _apptypes = [];
            component.appointmentTypes.forEach((appointmentType_id) => {
                let appointmentType = apptypes.find((appointmentType) => appointmentType.id === appointmentType_id);
                if (appointmentType) {
                    _apptypes.push(appointmentType.name);
                }
            });
            setApptypeStr(_apptypes.join(', '));
        }
    }, [resources, booking === null || booking === void 0 ? void 0 : booking.appointments]);
    useEffect(() => {
        var _a, _b;
        if (((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            if (selectedCapacity > 1) {
                if (selectedCapacityGroups[0]) {
                    setCapacityStr(ts('%capacity% personen', { capacity: selectedCapacity.toString() }, 'summary'));
                }
                else {
                    let parts = [];
                    const view = flow.views.find((view) => {
                        var _a;
                        const groups = (_a = view === null || view === void 0 ? void 0 : view.components) === null || _a === void 0 ? void 0 : _a.find((component) => {
                            if (component.picker === 'capacity') {
                                return component.config.groups;
                            }
                            return undefined;
                        });
                        return groups === null || groups === void 0 ? void 0 : groups.config.groups;
                    });
                    const groups = (_b = view === null || view === void 0 ? void 0 : view.components) === null || _b === void 0 ? void 0 : _b.find((component) => {
                        if (component.picker === 'capacity') {
                            return component.config.groups;
                        }
                        return undefined;
                    });
                    for (const [_key, _value] of Object.entries(selectedCapacityGroups)) {
                        if (_key !== '0' && _value > 0) {
                            let groupName = groups === null || groups === void 0 ? void 0 : groups.config.groups.find((group) => group.id === parseInt(_key)).name;
                            parts.push(ts('%capacity% %groupName%', { capacity: _value, groupName: t(groupName) }, 'summary'));
                        }
                    }
                    setCapacityStr(parts.join(', '));
                }
            }
            else {
                setCapacityStr('');
            }
        }
    }, [selectedCapacityGroups, selectedCapacity, booking === null || booking === void 0 ? void 0 : booking.appointments]);
    const restart = (e) => {
        let target = e.target.closest('button');
        let path = target.getAttribute('rel');
        resetBooking();
        resetCart();
        let d = new Date();
        d.setHours(0);
        d.setMinutes(0);
        setSelectedDate(d);
        setSelectedTime(d); // set the selected time explicitly to a time in the past, so the useDates and useTimes queries invalidate
        setIsPaying(false);
        queryClient.removeQueries();
        queryClient.invalidateQueries();
        setTimeout(() => {
            navigate(`/oa_widget_${path}`);
        }, 200);
    };
    const renderLine = (line, product, i) => {
        var _a;
        if (!product) {
            return (_jsx(Fragment, {}, i));
        }
        return (_jsxs(Fragment, { children: [_jsxs(TableRow, { rel: i.toString(), sx: {
                        backgroundColor: theme.palette.background.default,
                        height: '90px',
                        maxHeight: '90px'
                    }, children: [_jsxs(TableCell, { children: [_jsx(Typography, { gutterBottom: true, variant: "h5", component: "div", sx: {
                                        fontSize: '1rem',
                                        overflow: 'hidden',
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }, children: line.name }), product.subtitle && (_jsx(Typography, { variant: "body2", sx: Object.assign({ color: 'text.secondary', overflow: 'hidden', maxWidth: '150px', textOverflow: "ellipsis", whiteSpace: "nowrap" }, (smallMode && {
                                        maxWidth: '250px',
                                    })), children: product.subtitle }))] }), _jsx(StyledTableCell, { children: line.productType === 'product' && line.origin !== "requiredPurchase" && (_jsx(Box, { children: line.quantity })) }), _jsx(StyledTableCell, { sx: { width: '6em' }, children: moneyFormat(line.quantity * line.price) })] }, line.name), (_a = cart.lines) === null || _a === void 0 ? void 0 : _a.map((requiredLine, j) => {
                    // let product = getProduct(requiredLine.productId)
                    if (requiredLine.origin !== "requiredPurchase" || requiredLine.requiredBy !== line.productId) {
                        return (_jsx(Fragment, {}, `required-${j}`));
                    }
                    return (_jsxs(TableRow, { sx: {
                            backgroundColor: theme.palette.background.default,
                            height: '32px',
                            maxHeight: '32px'
                        }, children: [_jsxs(TableCell, { sx: {
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }, children: [" ", requiredLine.name] }), _jsx(TableCell, {}), _jsx(StyledTableCell, { children: moneyFormat(requiredLine.price) })] }, `required-${j}`));
                })] }, `line-${i}`));
    };
    const renderLines = useMemo(() => {
        var _a, _b;
        let lines = (_b = (_a = cart.lines) === null || _a === void 0 ? void 0 : _a.filter((line) => line.origin !== "requiredPurchase")) !== null && _b !== void 0 ? _b : [];
        if (lines.length === 0) {
            return (_jsx(_Fragment, {}));
        }
        return (_jsxs(_Fragment, { children: [orientation === "vertical" && (_jsx(Typography, { variant: "h5", sx: {
                        fontWeight: 500,
                        fontSize: '1.1rem',
                        margin: "16px 0"
                    }, children: t("Extra producten") })), _jsx(TableContainer, { id: "widget-cart-simple", sx: {
                        marginBottom: 4,
                        borderRadius: 0,
                        // overflowX: 'hidden'
                    }, component: Paper, children: _jsx(Table, { size: "small", "aria-label": t('Overzicht van je winkelwagen'), children: _jsx(TableBody, { sx: {
                                "& .MuiTableCell-body": {
                                    fontSize: '1rem'
                                }
                            }, children: lines.map((line, i) => {
                                let product = getProduct(line.productId);
                                if (line.origin === "requiredPurchase") {
                                    return (_jsx(Fragment, {}, i));
                                }
                                return (_jsx(_Fragment, { children: renderLine(line, product, i) }));
                            }) }) }) })] }));
    }, [cart.lines]);
    const renderDates = useMemo(() => {
        return (_jsx(_Fragment, { children: dates.map((date, i) => (_jsx(Typography, { variant: "subtitle2", sx: {
                    fontWeight: 700,
                    fontSize: '1.1rem',
                }, children: date }, `date-${i}`))) }));
    }, [dates]);
    const renderApptype = useMemo(() => {
        return (_jsx(_Fragment, { children: apptypeStr !== '' && (_jsx(Typography, { variant: "subtitle2", sx: {
                    fontWeight: 500,
                    fontSize: '1.1rem',
                }, children: apptypeStr })) }));
    }, [apptypeStr, apptypes]);
    const renderResource = useMemo(() => {
        return (_jsx(_Fragment, { children: showSelectedResource && resourceStr !== '' && (_jsx(Typography, { variant: "subtitle2", sx: {
                    fontWeight: 500,
                    fontSize: '1.1rem',
                }, children: resourceStr })) }));
    }, [showSelectedResource, resourceStr, resources]);
    const renderCapacity = useMemo(() => {
        return (_jsx(_Fragment, { children: capacityStr !== '' && (_jsx(Typography, { variant: "subtitle2", sx: {
                    fontWeight: 500,
                    fontSize: '1.1rem',
                }, children: capacityStr })) }));
    }, [capacityStr]);
    const renderRequiredAppProducts = useMemo(() => {
        var _a, _b;
        let lines = (_b = (_a = cart.lines) === null || _a === void 0 ? void 0 : _a.filter((line) => line.origin === "requiredPurchase" && line.requiredBy === "appointment")) !== null && _b !== void 0 ? _b : [];
        if (lines.length === 0) {
            return (_jsx(_Fragment, {}));
        }
        return (_jsx(_Fragment, { children: lines.map((line, i) => (_jsx(Typography, { variant: "subtitle2", sx: {
                    fontWeight: 500,
                    fontSize: '1.1rem',
                }, children: line.name }, i))) }));
    }, [cart.lines]);
    return (_jsxs(BoxContainer, { children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: t(orientation === "vertical" ? 'Bedankt voor de reservering' : 'Bedankt voor je aankoop') }), _jsxs(Alert, { sx: {
                    my: 3,
                    color: theme.palette.text.primary
                }, severity: "success", variant: "outlined", children: [orientation === "vertical" && (_jsxs(_Fragment, { children: [_jsxs(Typography, { variant: "caption", sx: {
                                    fontWeight: 500,
                                    fontSize: '0.9rem'
                                }, children: [t('Je huidige selectie', 'nav'), ":"] }), renderDates, renderApptype, renderResource, renderCapacity, renderRequiredAppProducts] })), orientation === "horizontal" && (_jsx(_Fragment, { children: _jsx(Typography, { variant: "caption", sx: {
                                fontWeight: 500,
                                fontSize: '0.9rem'
                            }, children: t('Je aankoop is voltooid', 'nav') }) }))] }), renderLines, showRestart && (_jsx(Button, { onClick: restart, rel: 'index', fullWidth: true, variant: "contained", children: t(orientation === "vertical" ? 'Nog een afspraak maken' : "Verder winkelen") }))] }));
}
